import { render, staticRenderFns } from "./ScheduleAssistant.vue?vue&type=template&id=53b491d8&scoped=true&"
import script from "./ScheduleAssistant.vue?vue&type=script&lang=ts&"
export * from "./ScheduleAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleAssistant.vue?vue&type=style&index=0&id=53b491d8&lang=scss&scoped=true&"
import style1 from "./ScheduleAssistant.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b491d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VRow,VSheet})
